// @flow
import gql from 'graphql-tag'

export type MediaType = 'image'

export type Media = {
  id: string,
  type: MediaType,
  url: string,
}

export const MEDIA_FRAGMENT = gql`
  fragment media on Media {
    id
    type
    url
  }
`
